module.exports = __webpack_public_path__ + "static/6-1b53cae85ee34a233fb57f4c42fb0481.jpg";